import SectionHeader from "../SectionHeader";
import Reveal from "../Reveal";

const WAYS = [
  {
    n: "01",
    img: "/illus/way-per-video.webp",
    title: "Per video, not per month.",
    text: "Eight videos a month is real work, just not a salary. Send them as they come, pay for what you use, scale up whenever you feel like it.",
  },
  {
    n: "02",
    img: "/illus/way-extra-hands.webp",
    title: "Extra hands when your team is stretched.",
    text: "Your editor is good and they're full. We take the overflow during launch weeks, in your style, so nothing waits its turn.",
  },
  {
    n: "03",
    img: "/illus/way-whole-function.webp",
    title: "The whole editing function, handled.",
    text: "One call sets it up. After that it runs: fixed monthly output, one account lead, no hiring and no managing.",
  },
];

export const Clients = () => (
  <section data-testid="clients-section" className="bg-[#111] section-pad">
    <div className="container-x">
      <SectionHeader
        eyebrow="Three ways people use us"
        eyebrowTestId="clients-eyebrow"
        title="Pick the one that sounds like you."
        support="Creators, product brands, agencies and businesses with a space."
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        {WAYS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08}>
            <div
              data-testid={`client-card-${c.n}`}
              className="group h-full rounded-2xl border border-white/10 bg-black/40 overflow-hidden hover:border-[#C8F031]/40 transition-colors duration-300"
            >
              <div className="aspect-[3/2] overflow-hidden bg-black border-b border-white/10">
                <img
                  src={c.img}
                  alt=""
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <div className="p-6 md:p-8">
                <p className="font-heading text-sm font-extrabold text-[#C8F031]">{c.n}</p>
                <p className="mt-4 font-heading text-lg md:text-xl font-bold text-white leading-snug">{c.title}</p>
                <p className="mt-3 text-sm text-white/50 leading-relaxed">{c.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Clients;
